import { Text, types } from "react-bricks/frontend"

import { EqualHeightElement } from "react-equal-height/clean"
import React from "react"
import classNames from "classnames"

export interface MatrixRedesignItemRowProps {
    index?: number
    row?: number
}

const MatrixRedesignItemRow: types.Brick<MatrixRedesignItemRowProps> = ({ index, row }) => {
    return (
        <div key={index} className={classNames("border-b border-border-tide py-3", { "pt-0": index === 0 })}>
            <EqualHeightElement name={"row-" + index + "-" + row}>
                <Text
                    propName="label"
                    renderBlock={({ children }) => <p className="mb-1 text-sm text-lighter-grey">{children}</p>}
                    placeholder="Lorem ipsum"
                />
                <Text
                    propName="text"
                    renderBlock={({ children }) => <p className="text-base font-semibold sm:text-md">{children}</p>}
                    placeholder="Lorem ipsum"
                />
            </EqualHeightElement>
        </div>
    )
}

MatrixRedesignItemRow.schema = {
    name: "MatrixRedesignItemRow",
    label: "Matrix Redesign Item Row",
    hideFromAddMenu: true,
}

export default MatrixRedesignItemRow
